import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchAPI } from '../../../api/request';
import { DetailConf } from '../conf/Detail.conf';
import { actions } from '../slice';

function* fetchDetail(action) {
  const { settings, params, query, body, token } = action.payload;

  if (settings && params && query && token) {
    try {
      yield put({ type: actions.loadingDetailChange.type });
      const response = yield call(
        fetchAPI,
        settings,
        params,
        query,
        body,
        token
      );
      yield put({ type: actions.dataDetailChange.type, payload: {data:response} });
    } catch (error) {
      yield put({ type: actions.errorDetailChange.type, error });
    }
  } else {
    yield put({
      type: actions.dataDetailChange.type,
      payload: { ...DetailConf.initialState },
    });
  }
}

export function* saga() {
  yield takeLatest(actions.fetchDetailAction, fetchDetail);
}
